<template>
    <div class="th-tabs th-tabs-bordered bg-grey-10 px-6 pt-2">
        <a class="th-tab th-tab-bordered " v-for="(item, index) in tabs" :key="index"
           :class="{ 'th-tab-bordered-active': item.name === activeTab}">
            <router-link :to="{ name: item.name, query: route.query }">
                {{ item.label }}
            </router-link>
        </a>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t } = useI18n()

const tabs = computed(() => [
    {
        name: 'overview',
        label: t('overview'),
    },
    {
        name: 'relation-ship',
        label: t('relationShip'),
    },
    {
        name: 'patent',
        label: t('patent'),
    },
    {
        name: 'paper',
        label: t('literature'),
    }
])

const route = useRoute();

const activeTab = computed(() => {
    return route.name
})

</script>
